import HeaderedContainer from '../headered-container/headered-container';
import { TruncatedBox } from '../truncated-textbox/truncated-box';
import styles from './headered-list.module.scss';

interface Props {
    title: string;
    items: { label: string, value: string | JSX.Element }[];
    // stickyTopPixels?: number;
    onShowExpandClick?: () => void;
    showExpand?: boolean;
}

export default function HeaderedList(props: Props) {

    return (
        <HeaderedContainer title={props.title} onShowExpandClick={props.onShowExpandClick} showExpand={props.showExpand}>
            <div className={styles.div_table}>
                {
                    props.items.map((i, idx) => {
                        return (
                            <div className={styles.div_table_row} key={i.label + "-" + idx}>
                                <div>{i.label}</div>
                                <div><TruncatedBox listKey={`${i.label}-${idx}`} text={i.value} /></div>
                            </div>
                        )
                    })
                }
            </div>
        </HeaderedContainer>
    )
}